import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Container, Logo, PreHeader } from '@scentregroup/ui'
import CentreFooter from '../../components/centre-footer'
import Header from '../../components/header'
import withCentre from '../../containers/with-centre'
import { centreType } from '../../types'
import getImageFromEntry, { MASTER } from '../../helpers/get-image-from-entry'
import WhatsHappeningListItem from '../../components/whats-happening-list-item'
import withWifiLanding from '../../containers/with-wifi-landing'
import {
  useEvolvedContext,
  TimeZoneContext,
  PromotionPositionContext,
} from '../../context'
import pagesHoc from '../pages-hoc'
import Sponsor from './sponsor'
import style from './index.module.scss'

const FreeWifi = ({ template, centre, loading, offer, store, items }) => {
  const isEvolved = useEvolvedContext()

  if (loading) {
    return null
  }
  const brand = centre.country === 'Australia' ? 'optus' : 'vodafone'

  const image = getImageFromEntry(offer, MASTER)

  // Construct url/link and location to offer.
  const category = offer.__typename.toLowerCase()
  let offerLink = null
  let location = null

  if (store) {
    offerLink = `/${centre.slug}/${category}/${offer.sys.id}/${offer.slug}`
    location = `${store.title}${
      store.landmarkDescription ? `, ${store.landmarkDescription}` : ''
    }`
  }

  return (
    <TimeZoneContext.Provider value={centre.timeZone}>
      <PromotionPositionContext.Provider
        value={template?.analyticsMetadata?.displayId}
      >
        <div className={style.preheader} role="banner">
          <div className={style[`outer-${brand}`]}>
            <Container centred type="large">
              <div className={style.inner}>
                <Sponsor
                  link={offerLink}
                  image={image}
                  heading={offer.title}
                  location={location}
                  body={offer.shortDescription}
                  brand={brand}
                  analyticsMetadata={offer.analyticsMetadata}
                />
              </div>
            </Container>
          </div>
          {!isEvolved && (
            <PreHeader className={style[`brandColour-${brand}`]}>
              <Link to="/" title="Home" className={style.logo}>
                <Logo />
              </Link>
            </PreHeader>
          )}
        </div>

        {!isEvolved && <Header centre={centre} />}

        <Container type="large" className={style.container}>
          {items.map(item => (
            <WhatsHappeningListItem {...item} key={item.link} />
          ))}
        </Container>

        {!isEvolved && <CentreFooter centre={centre} />}
      </PromotionPositionContext.Provider>
    </TimeZoneContext.Provider>
  )
}

FreeWifi.propTypes = {
  loading: PropTypes.bool,
  centre: centreType,
  offer: PropTypes.object.isRequired,
  store: PropTypes.object,
  items: PropTypes.array,
  template: PropTypes.shape({
    analyticsMetadata: PropTypes.shape({
      displayId: PropTypes.string,
    }),
  }),
}

export default withCentre(withWifiLanding(pagesHoc(FreeWifi)))
